import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  standalone: true,
  
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.scss',
  imports: [CommonModule]
})
export class ToggleSwitchComponent {
  @Input() isDisabled: boolean = false; // Estado inicial del toggle
  @Input() isToggled: boolean = false; // Estado inicial del toggle
  @Output() toggleChange = new EventEmitter<boolean>(); // Emisor de eventos para comunicar cambios

  toggle(): void {
    this.isToggled = !this.isToggled;
    this.toggleChange.emit(this.isToggled); // Emite el nuevo estado
  }
}
